import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';

const AbsenPage = ({ token }) => {
  // Default tanggal = Hari Ini
  const [selectedDate, setSelectedDate] = useState(new Date().toISOString().split('T')[0]);
  
  const [jadwalHariIni, setJadwalHariIni] = useState([]);
  const [selectedJadwal, setSelectedJadwal] = useState(''); 
  const [siswaList, setSiswaList] = useState([]);
  const [absenData, setAbsenData] = useState({}); 
  const [files, setFiles] = useState({}); 
  const [loading, setLoading] = useState(false);
  const [infoKelas, setInfoKelas] = useState(null);
  
  // State Mode Edit & Kunci
  const [isUpdateMode, setIsUpdateMode] = useState(false); 
  const [isLocked, setIsLocked] = useState(false); 

  const role = localStorage.getItem('role'); 

  // Helper Hari
  const getHariFromDate = (dateString) => {
    const days = ['Minggu', 'Senin', 'Selasa', 'Rabu', 'Kamis', 'Jumat', 'Sabtu'];
    const d = new Date(dateString);
    return days[d.getDay()];
  };

  // 1. AMBIL JADWAL SESUAI TANGGAL YG DIPILIH
  useEffect(() => {
    const fetchJadwal = async () => {
      try {
        const hariIni = getHariFromDate(selectedDate); 
        const namaGuruStorage = localStorage.getItem('nama') ? localStorage.getItem('nama').toLowerCase().trim() : '';

        // Menggunakan relative path
        const res = await axios.get('/api/jadwal', {
            headers: { Authorization: `Bearer ${token}` }
        });

        // ===================================================
        // EKSTRAKSI DATA IDENTITAS DARI PAYLOAD JWT TOKEN
        // ===================================================
        let jwtGuruId = null;
        let jwtGuruNama = null;

        if (token) {
            try {
                const base64Url = token.split('.')[1];
                const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
                const jsonPayload = decodeURIComponent(
                    atob(base64)
                        .split('')
                        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
                        .join('')
                );
                const decoded = JSON.parse(jsonPayload);
                
                jwtGuruId = decoded.guruId || decoded.id_guru || decoded.id || decoded.userId || decoded.sub;
                jwtGuruNama = decoded.nama || decoded.nama_guru || decoded.username || decoded.name;
                
                console.log("JWT DECODED ABSEN:", decoded);
            } catch (e) {
                console.error("Gagal membaca enkripsi token:", e);
            }
        }

        const targetId = jwtGuruId || localStorage.getItem('guruId') || localStorage.getItem('id_guru');
        const targetNama = (jwtGuruNama || namaGuruStorage || '').toLowerCase().trim();

        // FILTER JADWAL KETAT & AMAN
        const filtered = res.data.filter(j => {
            const matchHari = j.hari === hariIni;
            if (!matchHari) return false;

            if (role === 'admin' || role === 'kepsek' || role === 'piket' || role === 'wakasek') {
                return true;
            }
            
            if (targetId && j.guru_id) {
                if (j.guru_id == targetId) return true;
            }

            const namaDiJadwal = (j.nama_guru || j.nama || j.guru || '').toLowerCase().trim();
            if (targetNama && namaDiJadwal) {
                if (namaDiJadwal.includes(targetNama) || targetNama.includes(namaDiJadwal)) return true;
            }

            if (!targetId && !targetNama) {
                return true;
            }

            return false;
        });
        
        setJadwalHariIni(filtered);
        
        // Reset state jika ganti tanggal
        setSelectedJadwal('');
        setSiswaList([]);
        setInfoKelas(null);
        setIsLocked(false);
      } catch (err) {
        console.error(err);
      }
    };
    fetchJadwal();
  }, [token, selectedDate, role]);

  // 2. SAAT JADWAL DIPILIH -> CEK DATA LAMA & CEK WAKTU
  const handlePilihJadwal = async (e) => {
    const jId = e.target.value;
    setSelectedJadwal(jId);
    setSiswaList([]);
    setAbsenData({});
    setFiles({});
    setIsUpdateMode(false);
    setIsLocked(false); 

    if(!jId) return;

    const jadwal = jadwalHariIni.find(j => j.id == jId);
    if (!jadwal) return;
    
    setInfoKelas(`${jadwal.nama_kelas} - ${jadwal.mapel}`);
    setLoading(true);

    try {
        // A. Ambil Daftar Siswa 
        const resSiswa = await axios.get(`/api/siswa?kelas=${jadwal.nama_kelas}`, {
            headers: { Authorization: `Bearer ${token}` }
        });
        const dataSiswa = resSiswa.data;
        setSiswaList(dataSiswa);

        // B. Cek Data Absensi Lama 
        const resCek = await axios.get(`/api/absensi`, {
            params: { tanggal: selectedDate, kelas: jadwal.nama_kelas },
            headers: { Authorization: `Bearer ${token}` }
        });

        // Pengamanan tipe data array resCek
        const dataLama = Array.isArray(resCek.data) ? resCek.data : [];
        const initialAbsen = {};
        let dataFound = false;

        dataSiswa.forEach(s => {
            // --- LOGIKA DIPERKETAT: Utamakan mencocokkan jadwal_id agar tidak tertukar antar-jam pelajaran ---
            const exist = dataLama.find(d => 
                d.siswa_id === s.id && 
                (d.jadwal_id == jId || (d.jadwal_id === null && d.mapel === jadwal.mapel))
            );
            
            if (exist) {
                initialAbsen[s.id] = exist.status;
                dataFound = true;
            } else {
                initialAbsen[s.id] = 'hadir'; 
            }
        });

        setAbsenData(initialAbsen);

        if (dataFound) {
            setIsUpdateMode(true);
            
            if (role !== 'admin') {
                const now = new Date();
                const jamSekarang = now.toTimeString().split(' ')[0]; 
                const isHariIni = selectedDate === now.toISOString().split('T')[0];

                if (!isHariIni || jamSekarang > jadwal.jam_selesai) {
                    setIsLocked(true);
                    Swal.fire('Info', 'Waktu pelajaran sudah habis. Absensi terkunci.', 'info');
                } else {
                    setIsLocked(false); 
                }
            } else {
                const Toast = Swal.mixin({ toast: true, position: 'top-end', showConfirmButton: false, timer: 3000 });
                Toast.fire({ icon: 'info', title: 'Mode Edit (Admin Access)' });
            }
        }

    } catch (err) {
        console.error(err);
        Swal.fire('Gagal!', 'Gagal mengambil data.', 'error');
    }
    setLoading(false);
  };

  const handleStatusChange = (siswaId, status) => {
    if (isLocked) return; 
    setAbsenData(prev => ({ ...prev, [siswaId]: status }));
  };

  const handleFileChange = (siswaId, e) => {
    if (isLocked) return;
    if(e.target.files[0]) {
        setFiles(prev => ({ ...prev, [siswaId]: e.target.files[0] }));
    }
  };

  const handleInputPoin = async (siswaId, namaSiswa) => {
    const { value: formValues } = await Swal.fire({
      title: `Input Poin: ${namaSiswa}`,
      html:
        '<select id="swal-jenis" class="swal2-input">' +
        '  <option value="pelanggaran">⚠️ Pelanggaran</option>' +
        '  <option value="prestasi">🏆 Prestasi</option>' +
        '</select>' +
        '<input id="swal-poin" type="number" class="swal2-input" placeholder="Jumlah Poin">' +
        '<input id="swal-ket" class="swal2-input" placeholder="Keterangan">',
      focusConfirm: false,
      showCancelButton: true,
      confirmButtonText: 'Simpan Poin',
      preConfirm: () => {
        return {
          jenis: document.getElementById('swal-jenis').value,
          poin: document.getElementById('swal-poin').value,
          keterangan: document.getElementById('swal-ket').value
        }
      }
    });

    if (formValues) {
        if (!formValues.poin || !formValues.keterangan) return Swal.fire('Gagal', 'Lengkapi data!', 'warning');
        try {
            await axios.post('/api/poin', {
                siswa_id: siswaId,
                jenis: formValues.jenis,
                poin: parseInt(formValues.poin),
                keterangan: formValues.keterangan,
                input_by: role
            }, { headers: { Authorization: `Bearer ${token}` } });
            Swal.fire('Berhasil!', `Poin ${formValues.jenis} tercatat.`, 'success');
        } catch (error) { Swal.fire('Error', 'Gagal menyimpan poin.', 'error'); }
    }
  };

  const handleSubmit = async () => {
    if (isLocked) return; 

    const actionText = isUpdateMode ? 'Update Perubahan' : 'Simpan Absensi';
    const result = await Swal.fire({
      title: `${actionText}?`,
      text: `Kelas: ${infoKelas} | Tanggal: ${selectedDate}`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#4361ee',
      confirmButtonText: 'Ya, Simpan'
    });

    if (!result.isConfirmed) return;

    setLoading(true);
    try {
        const formData = new FormData();
        formData.append('tanggal', selectedDate); 
        formData.append('jadwal_id', selectedJadwal);
        
        const dataToSubmit = siswaList.map(s => ({
            siswa_id: s.id,
            status: absenData[s.id]
        }));
        formData.append('dataAbsen', JSON.stringify(dataToSubmit));

        Object.keys(files).forEach(sId => {
            formData.append(`bukti_${sId}`, files[sId]);
        });

        await axios.post('/api/absensi', formData, {
            headers: { 
                Authorization: `Bearer ${token}`,
                'Content-Type': 'multipart/form-data'
            }
        });

        Swal.fire('Sukses!', `Data berhasil ${isUpdateMode ? 'diperbarui' : 'disimpan'}.`, 'success');
        handlePilihJadwal({ target: { value: selectedJadwal } });

    } catch (err) {
        console.error(err);
        Swal.fire('Gagal!', 'Terjadi kesalahan server.', 'error');
    }
    setLoading(false); 
  };

  const getStatusColor = (status, current) => {
    const isSelected = status === current;
    const opacity = isLocked && !isSelected ? 0.3 : 1;
    const cursor = isLocked ? 'not-allowed' : 'pointer';

    const base = { 
        cursor, opacity, padding: '8px 10px', borderRadius: '6px', fontSize: '11px', fontWeight: 'bold', 
        textTransform: 'uppercase', transition: '0.2s' 
    };

    if (status === 'hadir') return { ...base, background: isSelected ? '#d1fae5' : '#f1f5f9', color: isSelected ? '#059669' : '#94a3b8', border: isSelected ? '1px solid #059669' : '1px solid transparent' };
    if (status === 'terlambat') return { ...base, background: isSelected ? '#ffedd5' : '#f1f5f9', color: isSelected ? '#ea580c' : '#94a3b8', border: isSelected ? '1px solid #ea580c' : '1px solid transparent' };
    if (status === 'sakit') return { ...base, background: isSelected ? '#fef3c7' : '#f1f5f9', color: isSelected ? '#d97706' : '#94a3b8', border: isSelected ? '1px solid #d97706' : '1px solid transparent' };
    if (status === 'izin') return { ...base, background: isSelected ? '#dbeafe' : '#f1f5f9', color: isSelected ? '#2563eb' : '#94a3b8', border: isSelected ? '1px solid #2563eb' : '1px solid transparent' };
    if (status === 'dispen') return { ...base, background: isSelected ? '#f3e8ff' : '#f1f5f9', color: isSelected ? '#7c3aed' : '#94a3b8', border: isSelected ? '1px solid #7c3aed' : '1px solid transparent' };
    if (status === 'alfa') return { ...base, background: isSelected ? '#fee2e2' : '#f1f5f9', color: isSelected ? '#dc2626' : '#94a3b8', border: isSelected ? '1px solid #dc2626' : '1px solid transparent' };
    
    return base;
  };

  return (
    <div style={{ padding: '20px', background: '#f8fafc', minHeight: '85vh' }}>
      <div style={{ maxWidth: '1100px', margin: '0 auto' }}>
        
        <h2 style={{ color: '#1e293b', marginBottom: '5px' }}>📝 Input Absensi & Poin</h2>
        
        {/* INPUT TANGGAL */}
        <div style={{ marginBottom: '20px', background: 'white', padding: '15px', borderRadius: '10px', display: 'flex', alignItems: 'center', gap: '10px', boxShadow: '0 2px 4px rgba(0,0,0,0.05)' }}>
            <label style={{ fontWeight: 'bold' }}>📅 Tanggal:</label>
            <input 
                type="date" 
                value={selectedDate} 
                onChange={(e) => setSelectedDate(e.target.value)}
                style={{ padding: '8px', borderRadius: '5px', border: '1px solid #ccc' }}
            />
            <span style={{ fontSize: '14px', color: '#64748b' }}>(Hari: <b>{getHariFromDate(selectedDate)}</b>)</span>
        </div>

        {/* PILIH JADWAL */}
        <div style={{ background: 'white', padding: '20px', borderRadius: '10px', boxShadow: '0 2px 4px rgba(0,0,0,0.05)', marginBottom: '20px' }}>
            <label style={{ fontWeight: 'bold', display: 'block', marginBottom: '10px' }}>Pilih Jam Pelajaran:</label>
            <select 
                value={selectedJadwal} onChange={handlePilihJadwal}
                style={{ width: '100%', padding: '12px', fontSize: '16px', borderRadius: '6px', border: '1px solid #cbd5e1' }}
            >
                <option value="">-- Pilih Jadwal {getHariFromDate(selectedDate)} --</option>
                {jadwalHariIni.length === 0 ? (
                    <option disabled>Tidak ada jadwal mengajar untuk hari {getHariFromDate(selectedDate)}.</option>
                ) : (
                    jadwalHariIni.map(j => (
                        <option key={j.id} value={j.id}>
                            ⏰ {j.jam_mulai.slice(0,5)} - {j.nama_kelas} ({j.mapel})
                        </option>
                    ))
                )}
            </select>
            
            {/* ALERT STATUS */}
            {isLocked && <div style={{ marginTop:'10px', color:'#b91c1c', background:'#fee2e2', padding:'10px', borderRadius:'6px', fontSize:'13px', fontWeight:'bold' }}>🔒 WAKTU HABIS: Jam pelajaran telah usai. Hubungi Admin untuk edit.</div>}
            {!isLocked && isUpdateMode && <div style={{ marginTop:'10px', color:'#d97706', fontSize:'13px', fontStyle:'italic' }}>⚠️ Mode Edit: Anda sedang mengubah data yang sudah ada.</div>}
        </div>

        {/* TABEL ABSENSI */}
        {siswaList.length > 0 && (
            <div style={{ background: 'white', padding: '25px', borderRadius: '10px', boxShadow: '0 4px 6px rgba(0,0,0,0.05)' }}>
                <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', borderBottom: '1px solid #eee', paddingBottom: '10px' }}>
                    <h3 style={{ margin:0, color: '#4361ee' }}>Kelas: {infoKelas}</h3>
                    <div style={{ fontSize:'12px', color:'#64748b' }}>Total: {siswaList.length} Siswa</div>
                </div>

                <div style={{ overflowX: 'auto' }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '15px' }}>
                        <thead>
                            <tr style={{ background: '#f1f5f9', textAlign: 'left', color: '#475569' }}>
                                <th style={{ padding: '12px', width:'5%' }}>No</th>
                                <th style={{ padding: '12px', width:'25%' }}>Nama Siswa</th>
                                <th style={{ padding: '12px', textAlign: 'center' }}>Status Kehadiran</th>
                                <th style={{ padding: '12px', width:'15%' }}>Bukti (Skt/Izn)</th>
                                <th style={{ padding: '12px', textAlign:'center', width:'10%' }}>Poin</th>
                            </tr>
                        </thead>
                        <tbody>
                            {siswaList.map((siswa, idx) => (
                                <tr key={siswa.id} style={{ borderBottom: '1px solid #f1f5f9' }}>
                                    <td style={{ padding: '12px', textAlign:'center' }}>{idx + 1}</td>
                                    <td style={{ padding: '12px', fontWeight: '500' }}>{siswa.nama}</td>
                                    <td style={{ padding: '12px', textAlign: 'center' }}>
                                        <div style={{ display: 'flex', gap: '5px', justifyContent: 'center', flexWrap:'wrap' }}>
                                            {['hadir', 'terlambat', 'sakit', 'izin', 'dispen', 'alfa'].map(status => {
                                                const style = getStatusColor(status, absenData[siswa.id]);
                                                return (
                                                    <label key={status} style={{ ...style }} title={status}>
                                                        <input 
                                                            type="radio" 
                                                            name={`status_${siswa.id}`} 
                                                            value={status}
                                                            checked={absenData[siswa.id] === status}
                                                            onChange={() => handleStatusChange(siswa.id, status)}
                                                            disabled={isLocked}
                                                            style={{ display: 'none' }}
                                                        />
                                                        {status === 'terlambat' ? 'T' : status === 'dispen' ? 'D' : status.charAt(0)}
                                                    </label>
                                                )
                                            })}
                                        </div>
                                    </td>
                                    <td style={{ padding: '12px' }}>
                                        {(['sakit', 'izin', 'dispen'].includes(absenData[siswa.id])) && !isLocked && (
                                            <input type="file" accept="image/*" onChange={(e) => handleFileChange(siswa.id, e)} style={{ fontSize: '11px', maxWidth: '150px' }} />
                                        )}
                                    </td>
                                    <td style={{ padding: '12px', textAlign:'center' }}>
                                        <button onClick={() => handleInputPoin(siswa.id, siswa.nama)} style={{ background: '#ef4444', color:'white', border:'none', padding:'6px 10px', borderRadius:'4px', cursor:'pointer', fontSize:'14px' }}>⚠️</button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                {!isLocked && (
                    <div style={{ marginTop: '25px', textAlign: 'right' }}>
                        <button 
                            onClick={handleSubmit}
                            disabled={loading}
                            style={{ padding: '12px 30px', background: isUpdateMode ? '#f59e0b' : '#4361ee', color: 'white', border: 'none', borderRadius: '6px', fontSize: '16px', fontWeight: 'bold', cursor: 'pointer', display:'flex', alignItems:'center', gap:'10px', marginLeft:'auto' }}
                        >
                            {loading ? 'Memproses...' : (isUpdateMode ? '🔄 Update Absensi' : '💾 Simpan Absensi')}
                        </button>
                    </div>
                )}
            </div>
        )}
      </div>
    </div>
  );
};

export default AbsenPage;